<template>
   <div>
        <div class="has-text-white top40 settsPad">
            <div class="is-size-3">DELETE ACCOUNT</div>
        </div>
        <div class="has-text-white is-size-5 top20  settsPad">
            You may request the complete deletion of your account and associated information.  Once requested, your account will be deleted within 10 business days. You will receive an email confirmation once the process has been completed.  Keep in mind that this action is not reversible. Click the button below to proceed.
        </div>
        <div v-if="sure == false" class=" settsPad">
            <button class="button is-coolGreen top20"  @click="del">DELETE ACCOUNT</button>
        </div>

        <div v-show="sure == 'yes'" class="has-text-left top30  settsPad">
            <div class="is-size-5 has-text-white">Are you sure you want to proceed? This will initiate the deletion of all your account data.</div>
            <button id="yes" class="button is-coolGreen top10"  @click="doDel">YES</button>&nbsp;
            <button class="button top10"  @click="cancel">NO</button>
        </div>

        <div v-if="sure == 'done'" class="top20  settsPad">
            <div class="is-size-5 has-text-white"><b>The deletion process for your account has been initiated. You will receive an email confirmation once completed.</b></div>
        </div>
        <br><br><br><br><br><br><br><br><br><br><br><br><br><br><br>
        <!-- <footerDiv></footerDiv> -->
   </div>
</template>

<script>
import { AZEventBus } from './AZEventBus'
import footerDiv from './Footer.vue'

export default{
    components: {footerDiv},
    data: function(){
        return {
            sure: false
        }
    },

    methods: {
        del: function(){
            this.sure = 'yes'
        },

        doDel: function(){
            var self = this
            function w(d){
                az.addRemSpinner(false, 'id', 'yes')
                self.sure = 'done'
            }

            function n(){
                az.addRemSpinner(false, 'id', 'yes')
            }

            az.addRemSpinner(true, 'id', 'yes')
            this.$root.app.apiClient.put('auth/account/delacc', {}, w, n)
        },

        cancel: function(){
            this.sure = false
        }
    }

}


</script>